import * as Yup from 'yup';
import { CommonMessages } from '../messages/validationMessages';

// Validation schema for Company Bank Info
export const CobankingInfoSchema = Yup.object({
    information: Yup.boolean(),

    paymentType: Yup.string()
        .required(CommonMessages.paymentType_required)
        .notOneOf(['0'], CommonMessages.paymentType_required), // Apply required and notOneOf validation

    accountname: Yup.string().required(CommonMessages.accountname_required),

    accountnumber: Yup.string()
        .required(CommonMessages.accountnumber_required)
        .matches(/^\d{12}$/, CommonMessages.accountnumber_mismatch),

    routingnumber: Yup.string()
        .required(CommonMessages.routingnumber_required)
        .matches(/^\d{9}$/, CommonMessages.routingnumber_mismatch),

    retypeaccountnumber: Yup.string()
        .required(CommonMessages.accountnumber_required)
        .matches(/^\d{12}$/, CommonMessages.accountnumber_mismatch)
        .trim()
        .oneOf([Yup.ref('accountnumber')], CommonMessages.accountnumber_match)
});

// Validation schema for Location Bank Info
export const ColocationbankingInfoSchema = Yup.object({
    information: Yup.boolean(),
    
    washlocation: Yup.string()
        .required(CommonMessages.location_required)
        .notOneOf(['0'], CommonMessages.paymentType_required),

    paymentType: Yup.string()
        .required(CommonMessages.paymentType_required)
        .notOneOf(['0'], CommonMessages.paymentType_required),

    accountname: Yup.string().required(CommonMessages.accountname_required),

    accountnumber: Yup.string()
        .required(CommonMessages.accountnumber_required)
        .matches(/^\d{12}$/, CommonMessages.accountnumber_mismatch),

    routingnumber: Yup.string()
        .required(CommonMessages.routingnumber_required)
        .matches(/^\d{9}$/, CommonMessages.routingnumber_mismatch),

    retypeaccountnumber: Yup.string()
        .required(CommonMessages.accountnumber_required)
        .matches(/^\d{12}$/, CommonMessages.accountnumber_mismatch)
        .trim()
        .oneOf([Yup.ref('accountnumber')], CommonMessages.accountnumber_match)
});
